import { createFileRoute } from "@tanstack/react-router";
import { RouteError } from "../../../shared/components/RouteError";
import { RoutePending } from "../../../shared/components/RoutePending";

/**
 * @purpose Add a parking spot to a location
 * @primary Station form
 * @persona danilo-tech
 */
export const Route = createFileRoute("/app/admin/stations/new")({
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
